var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuidde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "10 10 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9534 23.4615H42.7065C42.5546 23.4615 42.4089 23.5244 42.3016 23.6363C42.1943 23.7482 42.1341 23.9 42.1344 24.0581V25.8062C40.4227 24.0139 38.1556 23 35.8102 23C30.6726 23 26.3333 27.5554 26.3333 32.9486C26.3395 38.3939 30.579 42.8064 35.8102 42.8122C38.1812 42.7998 40.4525 41.8179 42.1344 40.0783V40.5444C42.1344 45.4692 40.0879 47.9666 36.052 47.9666C35.0952 47.9667 34.1531 47.7214 33.3091 47.2522C33.0649 47.1154 32.7614 47.1825 32.5915 47.4107L31.2481 49.1984C31.1452 49.335 31.1046 49.5115 31.1368 49.6818C31.1691 49.8522 31.271 49.9994 31.416 50.0852C32.8328 50.9064 34.4281 51.3361 36.0498 51.3333C38.7635 51.3333 41.0754 50.4302 42.7356 48.7241C44.5616 46.8467 45.5266 44.0184 45.5266 40.5444V24.0581C45.5266 23.7286 45.27 23.4615 44.9534 23.4615ZM35.7296 39.4467C32.3643 39.4467 29.7278 36.5927 29.7278 32.9486C29.7278 29.3046 32.4202 26.3656 35.7296 26.3656C39.0983 26.3656 42.0527 29.4409 42.0527 32.9486C42.0527 36.4564 39.1576 39.4467 35.7296 39.4467Z",
    fill: "#CB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0842 51.331H49.1069C49.4161 51.331 49.6667 51.0701 49.6667 50.7483V47.6018C49.6667 47.28 49.4161 47.0192 49.1069 47.0192H46.0842C45.775 47.0192 45.5244 47.28 45.5244 47.6018V50.7483C45.5244 51.0701 45.775 51.331 46.0842 51.331Z",
    fill: "#CB0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidde);
export default __webpack_public_path__ + "static/media/guidde.bfc31f189f4cfe7af1522f1e7092ecc9.svg";
export { ForwardRef as ReactComponent };